import { FirebaseOptions } from 'firebase/app';

export const firebaseWebConfig: FirebaseOptions = {
  apiKey: 'AIzaSyBSjZCfzzwrrexgaqxz5b-lvvgcEhKpWiw',
  authDomain: 'stoic-fluin-io.firebaseapp.com',
  projectId: 'stoic-fluin-io',
  storageBucket: 'stoic-fluin-io.firebasestorage.app',
  messagingSenderId: '1092484326500',
  appId: '1:1092484326500:web:caef6ab7f5ee215c59ab71',
};

export const firebaseAnalyticsMeasurementId = 'G-LKG8C6YFN2';

// Get this from Firebase Console > Project settings > Cloud Messaging > Web configuration.
export const firebaseWebVapidKey: string = 'BO04jjlp6mLeY7V_p6xlQl894Cuu7ie2Q3ICxCXNpuyc1Q3O29JgCzGg-hKyOScTpJfA-n8oAbk_ouSgJaLG_Uc';
